module.exports = "pegasus_template/assets/themelp1/small/logo.png";